import { Component, Input } from '@angular/core';

/**
 * Counter card for the PD area
 */
@Component({
  selector: 'project-valuation-counter-card',
  templateUrl: './project-valuation-counter-card.component.html'
})
export class ProjectValuationCounterCardComponent {
  /**
   * The link counter
   */
  @Input() linkCounter: any;
}
